import React, { useEffect, useState } from "react";
import { QRCodeSVG } from "qrcode.react";
import { useSelector } from "react-redux";
import goldBadge from "../../images/icons/gold_badge.svg";
import silverBadge from "../../images/icons/silver_badge.svg";
import platinumBadge from "../../images/icons/platinum_badge.svg";
import cross from "../../images/icons/close-button-icon.svg";

const QRCodeDrawer = ({ isOpen, onClose, langData }) => {
  const [isNotVisible, setIsNotVisible] = useState(false);
  
  const guestInformation = useSelector(
    (store) => store.guestInformation.member.data
  );

  const guest = guestInformation?.guest;
  const rewardsInfo = guestInformation?.rewardsInfo;
  const level = guestInformation ? rewardsInfo?.level : "Silver";
  const membershipNumberFormatted = guestInformation
    ? guest?.formattedAyanaRewardId
    : ""; 
  const membershipNumber = guestInformation
    ? guest?.ayanaRewardId
    : ""; 

  const fullName = guestInformation
    ? `${guest?.firstName} ${guest?.lastName}`
    : ""; 

  useEffect(() => {
    let timer;
    if (isNotVisible) {
      // Delay hiding the component until after the exit animation
      timer = setTimeout(() => onClose(), 300);
    }
    return () => clearTimeout(timer);
  }, [isNotVisible, onClose]);

  // Reset animation state when drawer opens
  useEffect(() => {
    if (isOpen) {
      setIsNotVisible(false);
    }
  }, [isOpen]);

  const getLevelIcon = (level) => {
    switch (level) {
      case "Gold":
        return goldBadge;
      case "Platinum":
        return platinumBadge;
      case "Silver":
      default:
        return silverBadge;
    }
  };
 

  if (!isOpen) return null;

  return (
    <>
      <div
        className="tw-w-screen tw-h-full md:tw-h-screen tw-fixed tw-inset-x-auto tw-top-0 tw-bg-black tw-opacity-[0.6] tw-z-[999]"
        onClick={() => setIsNotVisible(true)}></div>
      <div
        className={`tw-flex tw-flex-col tw-bg-white tw-fixed tw-bottom-0 md:tw-w-[480px] md:tw-bottom-auto md:tw-top-1/2 md:tw-left-1/2 md:tw-transform md:-tw-translate-x-1/2 md:-tw-translate-y-1/2 tw-w-screen tw-z-[9999] tw-gap-4 tw-px-4 tw-pt-4 md:tw-pt-6 tw-pb-[60px] md:tw-pb-10 md:tw-px-10 tw-rounded-tl-[16px] tw-rounded-tr-[16px] md:tw-rounded-[4px]
    ${
      isNotVisible
        ? "tw-animate-slideOutToBottom md:tw-animate-none"
        : "tw-animate-slideInFromBottom md:tw-animate-none"
    }
    tw-overflow-hidden`}
        style={{ overflowY: "auto" }}>
          <img
            src={cross}
            height={16}
            width={16}
            style={{ alignSelf: "end", cursor: "pointer" }}
            onClick={() => setIsNotVisible(true)}></img>

          {/* Drawer title */}
          <div className="tw-text-left">
            <div 
              className="tw-font-opensans tw-font-semibold md:tw-text-[20px] tw-text-[16px] tw-leading-[100%] tw-tracking-[0px] tw-text-gray-800"
            >
              {langData?.scan_membership_id || "Membership QR"}
            </div>
          </div>
          
          <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-border-2 tw-border-solid tw-border-gray-200 tw-rounded-lg tw-mx-auto tw-pt-6">
            {/* Member name */}
            <div className="tw-text-center">
              <h3 
                className="tw-font-gotham tw-font-medium tw-text-[16px] tw-leading-[100%] tw-tracking-[-0.4px] tw-text-gray-800 tw-color-[#111111]"
              >
                {fullName}
              </h3>
            </div>

            {/* Membership number */}
            <div className="tw-text-center">
              <p className="tw-font-opensans tw-font-normal tw-text-[14px] tw-leading-[100%] tw-tracking-[0px] tw-text-gray-600">{membershipNumberFormatted}</p>
            </div>

            {/* Membership level with icon */}
            <div className="tw-flex tw-items-center tw-justify-center tw-gap-2 ">
              <img
                src={getLevelIcon(level)}
                alt={level}
                className="tw-w-[20px] tw-h-[20px]"
              />
              <span className="tw-text-sm tw-font-medium tw-text-gray-700">
                {level} Level
              </span>
            </div>
            
            {/* QR Code */}
            <div className="tw-flex tw-justify-center tw-mb-4">
              <div className="tw-p-4 tw-bg-white tw-border tw-border-gray-200 tw-rounded-lg">
                {membershipNumber ? (
                  <QRCodeSVG
                    value={`${membershipNumber}`}
                    size={240}
                    level="M"
                    includeMargin={true}
                  />
                ) : (
                  <div className="tw-flex tw-justify-center tw-items-center tw-h-full">
                    <p className="tw-font-opensans tw-font-normal tw-text-[14px] tw-leading-[21px] tw-tracking-[0px] tw-text-center tw-text-gray-600">No membership number</p>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Footnote */}
          <div className="tw-flex tw-justify-center">
            <div className="tw-text-center">
              <p className="tw-font-opensans tw-font-normal tw-text-[14px] tw-leading-[21px] tw-tracking-[0px] tw-text-center tw-text-gray-600">
                {langData?.qr_code_footnote || "Please present this code at participating venues to enjoy your member discount."}
              </p>
            </div>
          </div>
      </div>
    </>
  );
};

export default QRCodeDrawer;
